import { functions } from './firebase';
const personnummer = require('personnummer.js');

export const saveMember = async ({ userId, user, setUser, usersWithSamePersonalId, setUsersWithSamePersonalId, legacyMember }) => {
  // console.log("Will save member.");
  // console.log("Member: ", user);

  if (!user) { return; }

  const physicalMemberCard = typeof user.physicalMemberCard !== 'undefined'
    ? user.physicalMemberCard
    : false;

  try {
    // Filter usersWithSamePersonalId data before sending.
    const _usersWithSamePersonalId = usersWithSamePersonalId?.map((user) => {
      return {
        id: user.id,
        reset: user.reset,
      }
    });
    // console.log("saveResponse: ");
    // console.log("storeGroupId: user.storeGroup.id, ", user);
    const saveResponse = await functions.httpsCallable('saveMember')({
      id: user.id,
      isNewMember: user.isNewMember,
      physicalMemberCard: user.physicalMemberCard,
      usersWithSamePersonalId: _usersWithSamePersonalId,
      firstName: user.firstName,
      lastName: user.lastName,
      membershipActive: user.membershipActive,
      membershipExpirationTimestamp: user.membershipExpirationTimestamp.toJSON(),
      personalId: !user.hasNoPersonalId ? personnummer.normalise(user.personalId) : "",
      hasNoPersonalId: user.hasNoPersonalId,
      lmaNumber: user.lmaNumber,
      birthDate: user.birthDate,
      storeGroupId: user.storeGroup.id,
      memberCategory: user.memberCategory,
      district: user.district,
      notes: user.notes,
      legacyMember: legacyMember,
    });
    // console.log("saveResponse: ", saveResponse);


    if (saveResponse && typeof saveResponse.data !== 'undefined' && saveResponse.data !== null && saveResponse.data.error) {
      alert(saveResponse.data.error);
    }
    if (saveResponse && typeof saveResponse.data !== 'undefined' && saveResponse.data !== null && !saveResponse.data.error) {
      if (usersWithSamePersonalId.length > 0) {
        setUsersWithSamePersonalId([]);
      }
      if (saveResponse.data.memberId === null &&
        user.membershipActive === true) {
        // If membershipActive, we should have a memberId.
        // If not, notify user. Could be that we've
        // reached the max allowed memberId.
        alert("Kunde inte tilldela medlemsnummer.");
      }

      if (user.isNewMember === true) {
        if (typeof saveResponse.data.id === 'string') {
          // userId.current = saveResponse.data.id;
          userId.current = saveResponse.data.id;
          setUser({
            ...user,
            id: saveResponse.data.id,
            memberId: saveResponse.data.memberId,
          });
          // history.push('/kunder/' + saveResponse.data.id);
        }
      }
    }

    return { success: true, message: "Ändringar sparade. " };
  } catch (error) {
    console.error("Could not save member. ", error);
    return { success: false, message: "Kunde inte spara. " + error.message };
  }


};

